import React from 'react';
import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
} from '@mui/material';
import { CustomTextArea } from './CustomTextArea';
import { Dropdown, Form } from 'react-bootstrap';

export const renderTextField = (
  label,
  name,
  value,
  onChange,
  isRequired = false,
  sx = {},
  disabled = false,
) => (
  <TextField
    required={isRequired}
    label={label}
    name={name}
    value={value}
    autoFocus={true}
    onChange={onChange}
    disabled={disabled}
    variant="standard"
    sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(33.33% - 16px)' }, ...sx }}
  />
);

export const renderSelectField = (
  label,
  name,
  value,
  onChange,
  options,
  isRequired = false,
  style = {},
  disabled = false,
) => (
  <FormControl
    variant="standard"
    sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 16px)' }, ...style }}
  >
    <InputLabel>{label}</InputLabel>
    <Select
      disabled={disabled}
      value={value}
      onChange={(e) => onChange(e, name)}
      label={label}
      name={name}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
    <FormHelperText>
      {isRequired && value === '' && (
        <span className="mandatoryField">* Required</span>
      )}
    </FormHelperText>
  </FormControl>
);
export const renderInputField = (
  label,
  name,
  value,
  onChange,
  isRequired = false,
  style = '',
  disabled = false,
  isNumber = false,
) => (
  <div className={`form-group ${style}`}>
    <label htmlFor={name}>
      {label}
      {isRequired && <span className="mandatory_fields">*</span>}
    </label>
    <input
      required={isRequired}
      type={isNumber ? 'number' : 'text'}
      className="form-control"
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);

export const renderInputFieldWithoutLabel = (
  name,
  value,
  onChange,
  isRequired = true,
  style = '',
  disabled = false,
) => (
  <div className={`form-group ${style}`}>
    <input
      required={isRequired}
      type="text"
      className="form-control"
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);

export const renderInputFieldWithTextBox = (
  name,
  value,
  onChange,
  style = '',
  label,
) => (
  <div className={`form-group ${style}`}>
    {label && <label htmlFor={name}>{label}</label>}
    <CustomTextArea name={name} value={value} onChange={onChange} />
  </div>
);

export const renderDropdown = (label, name, value, options, onChange) => (
  <div className="form-group" style={{ marginTop: '28px' }}>
    <div className="input-group mb-3">
      <div className="input-group-prepend">
        <label className="input-group-text">{label}</label>
      </div>
      <select
        className="custom-select"
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required
      >
        {options
          ? options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))
          : null}
      </select>
    </div>
  </div>
);

export const renderDropdownWithoutLabel = (
  name,
  value,
  options,
  onChange,
  index,
) => (
  <div className="form-group">
    <div className="input-group mb-3">
      <select
        className="custom-select"
        onClick={(e) => e.stopPropagation()}
        id={name}
        name={name}
        value={value}
        onChange={(e) => onChange(e, index, name)}
        required
      >
        {options
          ? options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))
          : null}
      </select>
    </div>
  </div>
);
export const renderDropdownWithoutLabelMultiple = (
  name,
  value,
  options,
  onChange,
  index,
  noOfDropdowns,
) => {
  return (
    <div className="form-group">
      <div className="input-group mb-3 flex flex-column">
        {Array.from({ length: Math.min(noOfDropdowns, 6) }).map((_, i) => (
          <select
            className="custom-select w-100"
            id={name}
            name={name}
            value={value[i]}
            onChange={(e) => onChange(e, index, name, i)}
            required
          >
            {options && options.length > 0 ? (
              options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))
            ) : (
              <option value="" disabled>
                No options available
              </option>
            )}
          </select>
        ))}
      </div>
    </div>
  );
};
export const renderDropwdownWithCheckbox = (
  checkboxes,
  onChange,
  label = '',
  name,
) => (
  <Dropdown>
    <Dropdown.Toggle variant="primary" id="dropdown-basic">
      {label}
    </Dropdown.Toggle>

    <Dropdown.Menu align={'right'}>
      <Form className="fancy-checkbox">
        {checkboxes &&
          checkboxes.map((checkbox, index) => (
            <li key={checkbox.name} style={{ flex: 1 }}>
              <label className="fancy-checkbox" style={{ marginTop: '10px' }}>
                <input
                  type="checkbox"
                  name={checkbox.name}
                  checked={checkbox.checked}
                  onChange={(e) => {
                    onChange(e, index);
                  }}
                />
                <span>{checkbox.label}</span>
              </label>
            </li>
          ))}
      </Form>
    </Dropdown.Menu>
  </Dropdown>
);

export const renderCheckboxes = (
  checkboxes,
  onChange,
  label = '',
  name,
  otherValue,
  isColumnDisplay = false,
  isDisabled = false,
) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <br />
      <ul className="list-unstyled" style={{ display: 'flex' }}>
        {checkboxes
          ? checkboxes.map((checkbox, index) => (
              <li key={checkbox.name} style={{ flex: 1 }}>
                <label className="fancy-checkbox" style={{ marginTop: '10px' }}>
                  <input
                    type="checkbox"
                    name={checkbox.name}
                    checked={checkbox.checked}
                    disabled={isDisabled}
                    onChange={(e) => {
                      onChange(e, index);
                    }}
                  />
                  <span
                    className={isColumnDisplay ? 'flex-checkbox-column' : ''}
                  >
                    {checkbox.label}
                  </span>
                </label>
                {(checkbox.name === 'Other' || checkbox.name === 'Others') &&
                checkbox.checked ? (
                  <div style={{ flex: 1 }}>
                    <CustomTextArea
                      minRows={2}
                      maxRows={3}
                      value={otherValue}
                      onChange={onChange}
                      name="otherValue"
                    />
                  </div>
                ) : null}
              </li>
            ))
          : null}
      </ul>
    </div>
  );
};
